import { useCallback } from "react";
import { useAuthStore } from "@/stores/authStore";

const DEFAULT_USER_COLOR = "#4a90e2";

/**
 * 사용자 프로필 관리 훅
 * authStore의 user가 이미 프로필 데이터를 포함하고 있음
 * SQL 함수를 통해 컬러 업데이트
 */
export function useUserProfile() {
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);
  const updateUserColorAction = useAuthStore((state) => state.updateUserColor);

  // 사용자 컬러 업데이트 (RPC 호출)
  const updateUserColor = useCallback(
    async (color: string): Promise<boolean> => {
      if (!user) {
        console.error("User not authenticated");
        return false;
      }

      // HEX 컬러 형식 검증
      if (!/^#[0-9A-Fa-f]{6}$/.test(color)) {
        console.error("Invalid color format:", color);
        return false;
      }

      const { error } = await updateUserColorAction(color);

      if (error) {
        console.error("Error updating user color:", error);
        return false;
      }

      return true;
    },
    [user, updateUserColorAction]
  );

  // 현재 사용자 컬러 가져오기
  const getUserColor = useCallback((): string => {
    return user?.user_color || DEFAULT_USER_COLOR;
  }, [user]);

  // 프로필 로드 (호환성 유지, 실제로는 authStore에서 이미 로드됨)
  const loadProfile = useCallback(async () => {
    // authStore의 user가 이미 프로필 데이터를 포함하고 있어서 별도 로드 불필요
  }, []);

  return {
    profile: user,
    isLoading,
    userColor: getUserColor(),
    updateUserColor,
    loadProfile,
  };
}
